import { Outlet, useLocation } from 'react-router-dom';
import { Box, Container, Paper, Typography } from '@mui/material';
import { useOffer } from '@core/offerContext.jsx';
import DocumentMeta from '@shared/components/DocumentMeta.jsx';
import { resolvePageMeta } from '@shared/seo/pageMeta.js';

export default function AuthLayout() {
  const { client } = useOffer();
  const { pathname } = useLocation();
  const meta = resolvePageMeta(pathname);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        py: 3,
      }}
    >
      <DocumentMeta title={meta.title} description={meta.description} path={pathname} />
      <Container maxWidth="sm">
        <Paper
          sx={{
            p: { xs: 3, sm: 4 },
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            boxShadow: '0 2px 12px rgba(47, 29, 15, 0.06)',
          }}
        >
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography variant="h5" fontWeight={700}>
              {client?.name || 'Happy Paws'}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Accès sécurisé à l’espace pro
            </Typography>
          </Box>
          <Outlet />
        </Paper>
      </Container>
    </Box>
  );
}
